class CustomFaq extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    this.items = this.querySelectorAll('.custom-faq__item');

    if (!this.items.length) return;

    this.items.forEach((item) => {
      const button = item.querySelector('.custom-faq__question');

      if (!button) return;

      button.addEventListener('click', () => {
        this.toggleItem(item);
      });
    });
  }

  toggleItem(item) {
    const button = item.querySelector('.custom-faq__question');
    const isOpen = item.classList.contains('is-open');

    item.classList.toggle('is-open', !isOpen);

    if (button) {
      button.setAttribute('aria-expanded', String(!isOpen));
    }
  }
}

if (!customElements.get('custom-faq')) {
  customElements.define('custom-faq', CustomFaq);
}